var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fund-size-details"},[_c('RkTabs',{attrs:{"options":_vm.options,"slider":""},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}}),_c(_vm.component,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }